var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EmptyState, FlexBox, Page, Table } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { Fragment, PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { NotificationLayout } from '../notification/notificationLayout';
import { FailedBulkActions } from './failedBulkActions';
import { FailedBulkToggle } from './failedBulkToggle';
import styles from './notificationsPage.module.scss';
export class NotificationsPage extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            openNotifications: [],
            failedActionData: {},
        };
    }
    componentDidMount() {
        const { notificationGetPersisted } = this.props;
        notificationGetPersisted()
            .then((res) => {
            // @TODO maybe implement loading indicators
        })
            .catch((err) => {
            // @TODO maybe implement loading/failure/retry
        });
    }
    getFailedBulkActions(bulkId) {
        const { notificationGetFailedBulkActions } = this.props;
        const { failedActionData } = this.state;
        if (!bulkId)
            return Promise.reject(new Error('No bulkID provided.'));
        return new Promise((resolve, reject) => {
            if (failedActionData[bulkId]) {
                resolve(failedActionData[bulkId]);
                return;
            }
            notificationGetFailedBulkActions(bulkId)
                .then((value) => {
                const { data: { failed_actions: faildedActions }, } = value;
                const newFailedActionData = faildedActions.reduce((pre, cur) => {
                    if (!pre[cur.bulk_id]) {
                        pre[cur.bulk_id] = [];
                    }
                    pre[cur.bulk_id].push({
                        actionType: cur.action_type,
                        agentId: cur.agent_id,
                        bulkId: cur.bulk_id,
                        conversationId: cur.conversation_id,
                        errorMessage: cur.error_message,
                        organizationId: cur.organization_id,
                        timestamp: cur.timestamp,
                    });
                    return pre;
                }, Object.assign({}, failedActionData));
                this.setState({
                    failedActionData: newFailedActionData,
                });
                if (newFailedActionData[bulkId]) {
                    return resolve(newFailedActionData[bulkId]);
                }
                return reject(new Error(`BulkID not found in failedActionData (bulkID: ${bulkId})`));
            })
                .catch(reject);
        });
    }
    onToggleFold(notification) {
        const { openNotifications } = this.state;
        if (!notification.bulkId)
            return;
        if (openNotifications.indexOf(notification.id) === -1) {
            this.setState({
                openNotifications: openNotifications.concat(notification.id),
            });
            this.getFailedBulkActions(notification.bulkId).catch((err) => {
                console.error(err);
            });
        }
        else {
            this.setState({
                openNotifications: openNotifications.filter((id) => id !== notification.id),
            });
        }
    }
    renderNotification(notification) {
        const { dispatch } = this.props;
        const { openNotifications, failedActionData } = this.state;
        const isOpen = openNotifications.indexOf(notification.id) !== -1;
        const { bulkStatus, bulkId } = notification;
        const isBulkAction = !!bulkId;
        const isBulkActionWithFailedActions = isBulkAction &&
            (bulkStatus === 'BulkActionFailed' ||
                bulkStatus === 'BulkActionPartialFailed');
        return (_jsxs(Fragment, { children: [_jsxs(Table.Tr, { children: [_jsx(Table.Td, { children: _jsx(NotificationLayout, { notification: notification.data }) }), _jsx(Table.Td, { children: notification.message }), _jsx(Table.Td, { children: isBulkAction && (_jsx(FailedBulkActions, { notification: notification, bulkStatus: bulkStatus, getFailedBulkActions: this.getFailedBulkActions, dispatch: dispatch })) }), _jsx(Table.Td, { children: isBulkActionWithFailedActions && (_jsx(FailedBulkToggle, { notification: notification, onClick: this.onToggleFold, open: isOpen })) })] }), isOpen && bulkId && failedActionData[bulkId] && (_jsx(Table.Tr, { children: _jsx(Table.Td, Object.assign({ colSpan: 4, className: styles.foldCell }, { children: _jsx(Table, { children: _jsx(Table.Tbody, { children: failedActionData[bulkId].map((failedAction, i) => (_jsx(Table.Tr, { children: _jsxs(Table.Td, Object.assign({ colSpan: 4, className: styles.failedActionCell }, { children: [_jsxs(Link, Object.assign({ to: `/conversation/${failedAction.conversationId}` }, { children: ["#", failedAction.conversationId] })), ' ', failedAction.errorMessage] })) }, i))) }) }) })) }))] }, notification.id));
    }
    render() {
        const { allNotifications } = this.props;
        const hasNotifications = !!allNotifications.length;
        return (_jsxs(Page, { children: [_jsx(Page.Head, { title: "Notifications" }), _jsx(Page.Body, { children: _jsxs(Page.Section, { children: [hasNotifications && (_jsx(Table, { children: _jsx(Table.Tbody, { children: allNotifications.map(this.renderNotification) }) })), !hasNotifications && (_jsx(FlexBox, Object.assign({ flexDirection: "column", alignItems: "center", justifyContent: "center", flex: "1", height: "100%" }, { children: _jsx(EmptyState, { title: "No notifications", description: "You are all caught up.", icon: "bell" }) })))] }) })] }));
    }
}
__decorate([
    boundMethod
], NotificationsPage.prototype, "getFailedBulkActions", null);
__decorate([
    boundMethod
], NotificationsPage.prototype, "onToggleFold", null);
__decorate([
    boundMethod
], NotificationsPage.prototype, "renderNotification", null);
